<template>
  <div class="realitySimulation">
    <div class="myimg">
      <img src="@/assets/zhineng/fangzhen.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {


    data () {
      return {

      };
    },

    mounted () {

    },

    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  .realitySimulation {
    // background-color: #152130;
    overflow: hidden;
    padding: 0px !important;

    .myimg {
      width: 100%;
      height: 100%;

      //  display: flex;
      //  align-items: center;
      //  justify-content: center;
      img {
        width: 100%;
        height: 100%;
        //  width: 58%;
        // height: 77%;
        // transform: scale(1.3);
      }
    }
  }
</style>